import axios from 'axios'

const API = process.env.VUE_APP_API_URL || 'http://127.0.0.1:5000'

export const getExercises = async (ids = []) => {
  const params = {}
  if (ids && ids.length) params.ids = ids.join(',')
  const res = await axios.get(`${API}/api/exercises`, { params })
  return res.data
}

export default { getExercises }


